import { MenuItem, Select } from '@mui/material';
import { allTimezones, useTimezoneSelect } from 'react-timezone-select';

import { Field } from '../../../../shared/Field/Field';

type Props = {
  label: string;
  value: string | null;
  onChange: (data: string | null) => void;
  tooltip?: string;
  required?: boolean;
  readOnly?: boolean;
  disabled?: boolean;
};

export const TimezonePicker = ({ label, value, onChange, tooltip, required, readOnly, disabled }: Props) => {
  const timezones = { ...allTimezones };
  delete timezones['Asia/Seoul'];
  timezones['Asia/Tokyo'] = 'Tokyo';
  timezones['Asia/Shanghai'] = 'Beijing, Shanghai, Hong Kong';

  const { options, parseTimezone } = useTimezoneSelect({
    labelStyle: 'original',
    timezones,
  });
  return (
    <Field fullWidth label={label} tooltip={tooltip} required={required}>
      <Select
        value={value || ''}
        onChange={(e) => onChange(parseTimezone(e.target.value).value)}
        {...{
          fullWidth: true,
          size: 'small',
          readOnly: readOnly,
          disabled: disabled,
        }}
      >
        <MenuItem value="" key={0} disabled>
          None
        </MenuItem>
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </Field>
  );
};
